import React from 'react';
import useI18n from '@/hooks/useI18n';
import { AlertCircleIcon } from '@/svg';

/**
 * Shown inside the campaign panel while a campaign is live but no creator has
 * posted yet, so the zeroed metrics below it read as "nothing yet" rather than
 * as a broken dashboard.
 */
const NoSubmissionsBanner: React.FC = () => {
  const { t } = useI18n();

  return (
    <div
      data-testid="no-submissions-banner"
      className="flex w-full items-center gap-4 rounded-2xl border border-[#FFA50033] bg-[#FFA5000A] p-5"
    >
      <div className="flex shrink-0 items-center justify-center rounded-full bg-white p-2">
        <AlertCircleIcon />
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <p className="font-header text-sm font-semibold text-[#121111]">
          {t('common.noSubmissionsYet')}
        </p>
        <p className="font-header text-[13px] font-normal text-black/70">
          {t('common.noSubmissionsYetDescription')}
        </p>
      </div>
    </div>
  );
};

export default NoSubmissionsBanner;
